import { Fragment } from "react";
import Link from "next/link";
import { ABSPRUNG_TEXT, wertText, type Kennzahl } from "./typen";

/**
 * Kandidat D: Projekt-Kennzahlen-Raster, Wert mit bis zu zwei Aufschlüsselungszeilen und Aktion.
 * Kann nicht: Ton, Trend, Symbol (der Block hat weder Statusfläche noch Pfeil noch Symbol).
 * Zusatz = Hinweiszeile unten, Absprung = unterstrichene Aktion (im Block ein Button, hier ein Link).
 */
export function KennzahlKachelD({ kennzahlen }: { kennzahlen: Kennzahl[] }) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
      {kennzahlen.map((k) => {
        const text = wertText(k);
        const zeilen = (k.aufschluesselung ?? []).slice(0, 2);
        return (
          <Fragment key={k.label}>
            {/* Preline: data-display/data-display-sub-analytics-kpis/data-display-cat-kpi-cards/project-metrics-grid */}
            <div className="p-5 flex flex-col bg-card border border-card-line shadow-xs rounded-xl">
              <div>
                <h2 className="text-sm text-muted-foreground-1">{k.label}</h2>
                <span className="block font-semibold text-xl text-foreground">
                  {text === null ? <span role="img" aria-label="nicht verfügbar">—</span> : text}
                </span>
              </div>

              {zeilen.length > 0 && (
                <div className="mt-3 flex flex-col gap-y-0.5">
                  {zeilen.map((z) => (
                    <div key={z.label} className="flex flex-wrap justify-between items-center gap-3">
                      <span className="text-[13px] text-muted-foreground-1">{z.label}:</span>
                      <span className="font-medium text-sm text-foreground">{z.wert}</span>
                    </div>
                  ))}
                </div>
              )}

              {(k.zusatz || k.href) && (
                <div className="mt-auto pt-2">
                  {k.zusatz && (
                    <div className="mb-1">
                      <p className="text-[13px] leading-2 text-muted-foreground-1">{k.zusatz}</p>
                    </div>
                  )}
                  {k.href && (
                    <Link
                      className="text-[13px] text-primary hover:decoration-2 underline underline-offset-4 focus:outline-hidden focus:decoration-2"
                      href={k.href}
                    >
                      {ABSPRUNG_TEXT}
                      <span className="sr-only">: {k.label}</span>
                    </Link>
                  )}
                </div>
              )}
            </div>
          </Fragment>
        );
      })}
    </div>
  );
}
